import _isArray from 'lodash/isArray'

import { mixpanelIdentify, mixpanelPeopleSet, mixpanelReset, mixpanelTrack } from '@taxfix/scouts-helpers'

import { PRICE_BUNDLE, PRICE_CURRENCY, PRICE_TAX_REGISTRATION } from '@/constants'

export const TRACK_VIEW_PAGE = 'VIEW_PAGE'

export const TRACK_USER_AUTHENTICATE = 'USER_AUTHENTICATE'
export const TRACK_USER_RESET_SESSION = 'USER_RESET_SESSION'
export const TRACK_USER_SIGNUP = 'USER_SIGNUP' // Added to useEventTracking

export const TRACK_TAX_REGISTRATION_VISIT_PAYWALL = 'TAX_REGISTRATION_VISIT_PAYWALL' // Added to useEventTracking
export const TRACK_TAX_REGISTRATION_COMPLETE_PAYMENT = 'TAX_REGISTRATION_COMPLETE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_REGISTRATION_INITIATE_PAYMENT = 'TAX_REGISTRATION_INITIATE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_REGISTRATION_START = 'TAX_REGISTRATION_START'
export const TRACK_TAX_REGISTRATION_SUBMIT = 'TAX_REGISTRATION_SUBMIT'

export const TRACK_TAX_RETURN_COMPLETE_PAY_LATER = 'TAX_RETURN_COMPLETE_PAY_LATER' // Added to useEventTracking
export const TRACK_TAX_RETURN_COMPLETE_PAYMENT = 'TAX_RETURN_COMPLETE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_RETURN_INITIATE_PAYMENT = 'TAX_RETURN_INITIATE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_RETURN_START = 'TAX_RETURN_START' // Added to useEventTracking
export const TRACK_TAX_RETURN_SUBMIT = 'TAX_RETURN_SUBMIT'
export const TRACK_TAX_RETURN_VISIT_PAYWALL = 'TAX_RETURN_VISIT_PAYWALL' // Added to useEventTracking

export const TRACK_PAYWALL_UPSELL_LEARN_MORE = 'PAYWALL_UPSELL_LEARN_MORE'
export const TRACK_PAYWALL_UPSELL_ADD = 'PAYWALL_UPSELL_ADD'
export const TRACK_PAYWALL_UPSELL_REMOVE = 'PAYWALL_UPSELL_REMOVE'

export const TRACK_TAX_CONSULTATION_COMPLETE_BOOKING = 'TAX_CONSULTATION_COMPLETE_BOOKING'
export const TRACK_TAX_CONSULTATION_COMPLETE_PAYMENT = 'TAX_CONSULTATION_COMPLETE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_CONSULTATION_INITIATE_BOOKING = 'TAX_CONSULTATION_INITIATE_BOOKING'
export const TRACK_TAX_CONSULTATION_INITIATE_PAYMENT = 'TAX_CONSULTATION_INITIATE_PAYMENT' // Added to useEventTracking
export const TRACK_TAX_CONSULTATION_START = 'TAX_CONSULTATION_START' // Added to useEventTracking
export const TRACK_TAX_CONSULTATION_VISIT_PAYWALL = 'TAX_CONSULTATION_VISIT_PAYWALL' // Added to useEventTracking

export const TRACK_PRODUCT_BUNDLE_START = 'PRODUCT_BUNDLE_START'
export const TRACK_PRODUCT_BUNDLE_VISIT_PAYWALL = 'PRODUCT_BUNDLE_VISIT_PAYWALL' // Added to useEventTracking
export const TRACK_PRODUCT_BUNDLE_INITIATE_PAYMENT = 'PRODUCT_BUNDLE_INITIATE_PAYMENT' // Added to useEventTracking
export const TRACK_PRODUCT_BUNDLE_COMPLETE_PAYMENT = 'PRODUCT_BUNDLE_COMPLETE_PAYMENT' // Added to useEventTracking

export const TRACK_CANCEL_PAYMENT = 'CANCEL_PAYMENT'

export const TRACK_CRYPTO_REPORT_START = 'CRYPTO_REPORT_START'
export const TRACK_CRYPTO_REPORT_DELETE = 'CRYPTO_REPORT_DELETE'
export const TRACK_CRYPTO_REPORT_NAVIGATE_BACK_TO_KOINLY = 'CRYPTO_REPORT_NAVIGATE_BACK_TO_KOINLY'
export const TRACK_CRYPTO_REPORT_CONFIRM = 'CRYPTO_REPORT_CONFIRM'
export const TRACK_CRYPTO_REPORT_DECLINE = 'CRYPTO_REPORT_DECLINE'

export const TRACK_GIG_START = 'GIG_START'
export const TRACK_GIG_CONNECTION_ADD = 'GIG_CONNECTION_ADD'
export const TRACK_GIG_CONNECTION_REMOVE = 'GIG_CONNECTION_REMOVE'
export const TRACK_GIG_CONNECTION_CANCEL = 'GIG_CONNECTION_CANCEL'
export const TRACK_GIG_CONFIRM_NO = 'GIG_CONFIRM_NO'
export const TRACK_GIG_CONFIRM_YES = 'GIG_CONFIRM_YES'
export const TRACK_GIG_MARK_AS_CORRECT = 'GIG_MARK_AS_CORRECT'
export const TRACK_GIG_MARK_AS_INCORRECT = 'GIG_MARK_AS_INCORRECT'
export const TRACK_GIG_NOTES_ADD = 'GIG_NOTES_ADD'

export const TRACK_COMPANY_RETURN_INITIATE_PAYMENT = 'COMPANY_RETURN_INITIATE_PAYMENT' // Added to useEventTracking
export const TRACK_COMPANY_RETURN_COMPLETE_PAYMENT = 'COMPANY_RETURN_COMPLETE_PAYMENT' // Added to useEventTracking

const setDataLayerEvent = (data) => {
    window.dataLayer = window.dataLayer || []

    if (_isArray(window.dataLayer) && data) {
        window.dataLayer.push(data)
    }
}

export const track = (action, data = {}) => {
    switch (action) {
        case TRACK_VIEW_PAGE: {
            const { profile, pathname, hash, search } = data

            const { selfDeclaredAttributionSource, isReturningCustomer, initialVariant } = profile

            mixpanelPeopleSet({
                'Self-declared Attribution Source': selfDeclaredAttributionSource,
                'Is Returning Customer': isReturningCustomer,
                'Initial Variant': initialVariant,
            })

            mixpanelTrack(TRACK_VIEW_PAGE, { Path: `/assessment${pathname}`, Hash: hash, Search: search })

            break
        }

        case TRACK_USER_AUTHENTICATE: {
            const { variant, initialVariant, referralSource, userId } = data

            mixpanelIdentify(userId)

            mixpanelPeopleSet({
                Variant: variant,
                'Referral Source': referralSource,
                'Initial Variant': initialVariant,
            })

            mixpanelTrack(TRACK_USER_AUTHENTICATE)

            break
        }

        case TRACK_USER_SIGNUP: {
            const { variant, initialVariant, referralSource } = data

            mixpanelPeopleSet({
                Variant: variant,
                'Referral Source': referralSource,
                'Initial Variant': initialVariant,
            })

            mixpanelTrack(TRACK_USER_SIGNUP)

            break
        }

        case TRACK_USER_RESET_SESSION: {
            mixpanelTrack(TRACK_USER_RESET_SESSION)

            break
        }

        case TRACK_TAX_REGISTRATION_START: {
            // Keeping for now as not yet migrated to useEventTracking
            // Migration would need further refactor of tax registration creation
            setDataLayerEvent({
                event: 'add_to_cart',
                ecommerce: {
                    currency: PRICE_CURRENCY,
                    value: PRICE_TAX_REGISTRATION,
                    items: [
                        {
                            item_id: 'TAX_REGISTRATION',
                            name: 'Tax registration',
                            price: PRICE_TAX_REGISTRATION,
                            quantity: 1,
                        },
                    ],
                },
            })

            mixpanelTrack(TRACK_TAX_REGISTRATION_START)

            break
        }

        case TRACK_TAX_REGISTRATION_SUBMIT: {
            mixpanelTrack(TRACK_TAX_REGISTRATION_SUBMIT)

            break
        }

        case TRACK_TAX_REGISTRATION_VISIT_PAYWALL: {
            mixpanelTrack(TRACK_TAX_REGISTRATION_VISIT_PAYWALL)

            break
        }

        case TRACK_TAX_REGISTRATION_INITIATE_PAYMENT: {
            mixpanelTrack(TRACK_TAX_REGISTRATION_INITIATE_PAYMENT)

            break
        }

        case TRACK_TAX_REGISTRATION_COMPLETE_PAYMENT: {
            mixpanelTrack(TRACK_TAX_REGISTRATION_COMPLETE_PAYMENT)

            break
        }

        case TRACK_TAX_RETURN_START: {
            const { taxYear } = data

            mixpanelTrack(TRACK_TAX_RETURN_START, { 'Tax Year': taxYear })

            break
        }

        case TRACK_TAX_RETURN_VISIT_PAYWALL: {
            const { isCIS, isProductBundleAvailable, isPayLaterAvailable } = data

            mixpanelTrack(TRACK_TAX_RETURN_VISIT_PAYWALL, {
                'Is CIS': !!isCIS,
                'Is Product Bundle Available': !!isProductBundleAvailable,
                'Is Pay Later Available': !!isPayLaterAvailable,
            })

            break
        }

        case TRACK_PAYWALL_UPSELL_LEARN_MORE: {
            mixpanelTrack(TRACK_PAYWALL_UPSELL_LEARN_MORE)

            break
        }

        case TRACK_PAYWALL_UPSELL_ADD: {
            mixpanelTrack(TRACK_PAYWALL_UPSELL_ADD)

            break
        }

        case TRACK_PAYWALL_UPSELL_REMOVE: {
            mixpanelTrack(TRACK_PAYWALL_UPSELL_REMOVE)

            break
        }

        case TRACK_TAX_RETURN_INITIATE_PAYMENT: {
            const { activeFilingAreas, taxYear } = data

            mixpanelTrack(TRACK_TAX_RETURN_INITIATE_PAYMENT, {
                'Tax Year': taxYear,
                'Filing Areas': activeFilingAreas,
            })

            break
        }

        case TRACK_TAX_RETURN_COMPLETE_PAYMENT: {
            const { activeFilingAreas, taxYear } = data

            mixpanelTrack(TRACK_TAX_RETURN_COMPLETE_PAYMENT, {
                'Tax Year': taxYear,
                'Filing Areas': activeFilingAreas,
            })

            break
        }

        case TRACK_CANCEL_PAYMENT: {
            mixpanelTrack(TRACK_CANCEL_PAYMENT)

            break
        }

        case TRACK_TAX_RETURN_SUBMIT: {
            const { taxYear } = data

            mixpanelTrack(TRACK_TAX_RETURN_SUBMIT, { 'Tax Year': taxYear })

            break
        }

        case TRACK_TAX_RETURN_COMPLETE_PAY_LATER: {
            const { taxYear } = data

            mixpanelTrack(TRACK_TAX_RETURN_COMPLETE_PAY_LATER, {
                'Tax Year': taxYear,
            })

            break
        }

        case TRACK_PRODUCT_BUNDLE_START: {
            // Keeping for now as not yet migrated to useEventTracking
            // Migration would need further refactor of bundle creation
            setDataLayerEvent({
                event: 'add_to_cart',
                ecommerce: {
                    currency: PRICE_CURRENCY,
                    value: PRICE_BUNDLE,
                    items: [
                        {
                            item_id: 'BUNDLE',
                            name: 'Bundle',
                            price: PRICE_BUNDLE,
                            quantity: 1,
                        },
                    ],
                },
            })

            mixpanelTrack(TRACK_PRODUCT_BUNDLE_START)

            break
        }

        case TRACK_PRODUCT_BUNDLE_VISIT_PAYWALL: {
            mixpanelTrack(TRACK_PRODUCT_BUNDLE_VISIT_PAYWALL)

            break
        }

        case TRACK_PRODUCT_BUNDLE_INITIATE_PAYMENT: {
            mixpanelTrack(TRACK_PRODUCT_BUNDLE_INITIATE_PAYMENT)

            break
        }

        case TRACK_PRODUCT_BUNDLE_COMPLETE_PAYMENT: {
            const { upsellBaseProductType } = data

            mixpanelTrack(TRACK_PRODUCT_BUNDLE_COMPLETE_PAYMENT, {
                'Is Upsell Purchase': !!upsellBaseProductType,
                'Upsell Base Product': upsellBaseProductType,
            })

            break
        }

        case TRACK_TAX_CONSULTATION_START: {
            mixpanelTrack(TRACK_TAX_CONSULTATION_START)

            break
        }

        case TRACK_TAX_CONSULTATION_VISIT_PAYWALL: {
            const { isProductBundleAvailable } = data

            mixpanelTrack(TRACK_TAX_CONSULTATION_VISIT_PAYWALL, {
                'Is Product Bundle Available': !!isProductBundleAvailable,
            })

            break
        }

        case TRACK_TAX_CONSULTATION_INITIATE_PAYMENT: {
            const { topics } = data

            mixpanelTrack(TRACK_TAX_CONSULTATION_INITIATE_PAYMENT, {
                Topics: topics,
            })

            break
        }

        case TRACK_TAX_CONSULTATION_COMPLETE_PAYMENT: {
            const { topics } = data

            mixpanelTrack(TRACK_TAX_CONSULTATION_COMPLETE_PAYMENT, {
                Topics: topics,
            })

            break
        }

        case TRACK_COMPANY_RETURN_INITIATE_PAYMENT: {
            mixpanelTrack(TRACK_COMPANY_RETURN_INITIATE_PAYMENT)

            break
        }

        case TRACK_COMPANY_RETURN_COMPLETE_PAYMENT: {
            mixpanelTrack(TRACK_COMPANY_RETURN_COMPLETE_PAYMENT)

            break
        }

        case TRACK_TAX_CONSULTATION_COMPLETE_BOOKING: {
            mixpanelTrack(TRACK_TAX_CONSULTATION_COMPLETE_BOOKING)

            break
        }

        case TRACK_TAX_CONSULTATION_INITIATE_BOOKING: {
            mixpanelTrack(TRACK_TAX_CONSULTATION_INITIATE_BOOKING)

            break
        }

        case TRACK_CRYPTO_REPORT_START: {
            mixpanelTrack(TRACK_CRYPTO_REPORT_START)

            break
        }

        case TRACK_CRYPTO_REPORT_DELETE: {
            mixpanelTrack(TRACK_CRYPTO_REPORT_DELETE)

            break
        }

        case TRACK_CRYPTO_REPORT_NAVIGATE_BACK_TO_KOINLY: {
            mixpanelTrack(TRACK_CRYPTO_REPORT_NAVIGATE_BACK_TO_KOINLY)

            break
        }

        case TRACK_CRYPTO_REPORT_CONFIRM: {
            mixpanelTrack(TRACK_CRYPTO_REPORT_CONFIRM)

            break
        }

        case TRACK_CRYPTO_REPORT_DECLINE: {
            mixpanelTrack(TRACK_CRYPTO_REPORT_DECLINE)

            break
        }

        case TRACK_GIG_START: {
            mixpanelTrack(TRACK_GIG_START)

            break
        }

        case TRACK_GIG_CONNECTION_ADD: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_CONNECTION_ADD, { Platform: platform })

            break
        }

        case TRACK_GIG_CONNECTION_REMOVE: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_CONNECTION_REMOVE, { Platform: platform })

            break
        }

        case TRACK_GIG_CONNECTION_CANCEL: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_CONNECTION_CANCEL, { Platform: platform })

            break
        }

        case TRACK_GIG_CONFIRM_NO: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_CONFIRM_NO, { Platform: platform })

            break
        }

        case TRACK_GIG_CONFIRM_YES: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_CONFIRM_YES, { Platform: platform })

            break
        }

        case TRACK_GIG_MARK_AS_INCORRECT: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_MARK_AS_INCORRECT, { Platform: platform })

            break
        }

        case TRACK_GIG_MARK_AS_CORRECT: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_MARK_AS_CORRECT, { Platform: platform })

            break
        }

        case TRACK_GIG_NOTES_ADD: {
            const { platform } = data

            mixpanelTrack(TRACK_GIG_NOTES_ADD, { Platform: platform })

            break
        }

        default:
    }
}

export const resetTracking = () => {
    mixpanelReset()
}
